const module = {
  routes: [
    {
      path: '/invoices',
      component: () => import('@/modules/invoices/pages/index.vue'),
      children: [],
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
